import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
  // TooltipLabel,
} from 'ngx-intl-tel-input-gg';

@Component({
    selector: 'pr-input-tel',
    templateUrl: './pr-input-tel.component.html',
    styleUrls: ['./pr-input-tel.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrInputTelComponent,
        },
        // {
        //   provide: NG_VALIDATORS,
        //   multi: true,
        //   useExisting: PrInputCheckboxComponent,
        // },
    ],
    standalone: false
})
export class PrInputTelComponent
  implements OnInit, ControlValueAccessor, OnChanges, AfterViewInit
{
  @Input() formControlName: string;
  @Input() derrors: boolean = false;
  @Input() label: string;
  @Input() disable: boolean = false;
  @Input() isDefault = true;
  @Input() highlightOnValue: boolean = false;
  @Input() highlightOnFocus: boolean = false;
  value;
  touched = true;
  disabled = false;
  hasValue: boolean = false;
  hasFocus: boolean = false;
  onChange: any = value => {};
  onTouched: any = () => {};
  prefex: string = '+33';
  // ngx-intl-tel-input
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  // TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.France,
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  @ViewChild('inputTel', { static: false })
  public inputTelElementRef: any;
  constructor(private controlContainer: ControlContainer) {}
  ngAfterViewInit(): void {}
  ngOnChanges(changes: SimpleChanges): void {}
  writeValue(value: any): void {}
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}
  onInputChange(event) {
    // this.value = event.target.value;
    // this.onChange(this.value);
  }

  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }
  ngOnInit() {
    if (this.control) this.value = this.control.value || '';
    this.hasValue = this.value && this.value.toString().trim() !== '';
    this.control.valueChanges.subscribe(value => {
      this.hasValue = value && value.toString().trim() !== '';
      if (value && this.inputTelElementRef && this.inputTelElementRef.value) {
        this.inputTelElementRef.value = value.internationalNumber;
        this.inputTelElementRef.phoneNumber = value.internationalNumber;
      }
    });
  }
  onCountryChange(event) {
    // this.prefex = "+" + event.dialCode;
  }
  getNumber(number) {}
  onBlur(event) {
    if (
      this.value &&
      this.inputTelElementRef &&
      this.inputTelElementRef.value
    ) {
      this.inputTelElementRef.value = this.value.internationalNumber;
      this.inputTelElementRef.phoneNumber = this.value.internationalNumber;
    }
  }

  telInputObject(obj: any) {
    obj.setNumber(this.value);
  }
  hasError(event) {}
  checkNumber(number) {}
}
//https://github.com/jackocnr/intl-tel-input/blob/master/README.md#initialisation-options
